import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { entityExportsApi } from 'src/Services/API';
import {
  EntityExportDto,
  EntityExportsControllerFindAllEntityTypeEnum,
} from 'src/Services/API/generated';

const useFetchPracticalInformationExports = () => {
  const assetId = useCurrentAssetId();

  const query = useQuery<EntityExportDto[]>({
    queryKey: ['fetch-practical-information-exports', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');

      return (
        await entityExportsApi.entityExportsControllerFindAll(
          assetId,
          EntityExportsControllerFindAllEntityTypeEnum.PracticalInformation
        )
      ).data;
    },
    enabled: !!assetId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });

  return {
    data: query.data ?? [],
    isLoading: query.isLoading,
    error: query.error,
  };
};

export default useFetchPracticalInformationExports;
